import http from '@/plugins/http';

export default {
    getSysTheme() {
        return http.GET(`api/System/GetSysTheme`);
    },
    saveSysThemeInfo(params) {
        return http.POST(`api/System/SaveSysThemeInfo`, params);
    },
    getSysThemeInfo() {
        return http.GET(`api/System/GetSysThemeInfo`);
    },
};
